import React from 'react';
import MainPageContainer from "./container/MainPageContainer";

function App() {
  return (
    <div className="App">
      <MainPageContainer/>
    </div>
  );
}

export default App;
